module.exports = __webpack_public_path__ + "img/fireworks.d5c8de7f.gif";